<template>
  <div
    class="flex flex-col overflow-y-auto border-r border-gray-200 bg-white pt-2 pb-2"
  >
    <div class="pt-4 pl-8 text-xl font-medium text-gray-900">
      <h1 class="truncate text-ellipsis w-40">
        {{ t("admin.navigation.organisation.label") }}
      </h1>
    </div>
    <div class="mt-5 flex flex-grow flex-col">
      <nav
        class="flex-1 space-y-8 bg-white px-4 sm:px-6 lg:px-8"
        aria-label="Sidebar"
      >
        <div class="space-y-1">
          <Link
            v-for="item in settings.filter((s) => !s.hidden)"
            :key="item.name"
            :href="item.href"
            :class="[
              isActive(item.href)
                ? 'bg-gray-50 text-gray-900 hover:text-gray-900 hover:bg-gray-100'
                : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50',
              'group flex items-center px-2 py-2 text-sm font-medium rounded-sm',
            ]"
          >
            <component
              :is="item.icon"
              :class="[
                isActive(item.href)
                  ? 'text-gray-900'
                  : 'text-gray-500 group-hover:text-gray-500',
                'mr-3 flex-shrink-0 h-5 w-5',
              ]"
              aria-hidden="true"
            />
            <span class="truncate flex-1">{{ item.name }}</span>
          </Link>
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>
import route from "ziggy-js";
import BuildingSeven from "@/Tailwind/Icon/BuildingSeven";
import SettingsThree from "@/Tailwind/Icon/SettingsThree";
import { computed, inject, unref } from "vue";
import { Link, usePage } from "@inertiajs/vue3";
import { useBreakpoints } from "@/Tailwind/Mixins/useBreakpoints";

import { useI18n } from "vue-i18n";
import { ArrowPathRoundedSquareIcon } from "@heroicons/vue/20/solid";
const { t } = useI18n();

const { type } = useBreakpoints();

const { hasPermission, permissions } = inject("permissions");

const isPartOfCustomer = computed(() => {
  if (!customers) {
    return false;
  }

  return customers.length >= 1;
});

const customers = usePage().props.auth.customers;
const settings = [
  {
    name: t("admin.settings.organisation.buildings"),
    icon: BuildingSeven,
    href:
      unref(type) === "xs"
        ? route("settings.organisation.index")
        : route("settings.organisation.buildings"),
    hidden: false,
  },
  {
    name: t("admin.settings.recurring_tasks.title"),
    icon: ArrowPathRoundedSquareIcon,
    href: route("settings.organisation.recurring-tasks.index"),
    current: false,
    hidden: !hasPermission(permissions.readRecurringTask),
  },
  {
    name: t("admin.settings.organisation.settings"),
    icon: SettingsThree,
    href: isPartOfCustomer.value
      ? route("settings.user.customer.show", customers[0])
      : "",
    // !isPartOfCustomer.value
    hidden: true,
  },
];

function isActive(to) {
  const url = `${location.origin}${location.pathname}`;

  return to === url;
}
</script>
